var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.9253C19 9.27068 18.9366 8.59494 18.831 7.96143H9.68738V11.6991H14.9244C14.7132 12.9028 14.0164 13.9586 12.9816 14.6344L16.1069 17.0628C17.9441 15.3524 19 12.8606 19 9.9253Z",
    fill: "#4280EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68738 19.3858C12.3059 19.3858 14.5021 18.52 16.1069 17.0418L12.9816 14.6345C12.1158 15.2257 10.9966 15.5636 9.68738 15.5636C7.15334 15.5636 5.02053 13.8531 4.2392 11.5725L1.02942 14.0432C2.67654 17.3163 6.01303 19.3858 9.68738 19.3858Z",
    fill: "#34A353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23923 11.5514C3.83801 10.3477 3.83801 9.03849 4.23923 7.83482L1.02945 5.34302C-0.343151 8.08822 -0.343151 11.3191 1.02945 14.0432L4.23923 11.5514Z",
    fill: "#F6B704"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68738 3.84366C11.06 3.82254 12.4115 4.35047 13.404 5.30073L16.1703 2.51329C14.4176 0.866165 12.0947 -0.0207484 9.68738 0.000368552C6.01303 0.000368552 2.67654 2.06983 1.02942 5.34296L4.2392 7.83477C5.02053 5.53302 7.15334 3.84366 9.68738 3.84366Z",
    fill: "#E54335"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.3de288f032d696461ba334a339f0333d.svg";
export { ForwardRef as ReactComponent };